export default "<div class=\"spinner\">\n\n</div>"